"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExactDataSet = exports.DatasetClass = exports.BaseSet = void 0;
const interfaces_1 = require("@build-5/interfaces");
const axios_1 = __importDefault(require("axios"));
const rxjs_1 = require("rxjs");
const __1 = require("..");
const fetch_utils_1 = require("../fetch.utils");
const GetByIdGrouped_1 = __importDefault(require("../get/GetByIdGrouped"));
const GetByIdGroupedLive_1 = __importDefault(require("../get/GetByIdGroupedLive"));
const observable_1 = require("../get/observable");
const AwardOwnerSubset_1 = require("./award/AwardOwnerSubset");
const AwardParticipantSubset_1 = require("./award/AwardParticipantSubset");
const CollectionStatsSubset_1 = require("./collection/CollectionStatsSubset");
const MilestoneTransactionSubset_1 = require("./milestone/MilestoneTransactionSubset");
const ProposalMemberSubset_1 = require("./proposal/ProposalMemberSubset");
const SpaceBlockedMemberSubset_1 = require("./space/SpaceBlockedMemberSubset");
const SpaceGuardianSubset_1 = require("./space/SpaceGuardianSubset");
const SpaceKnockingMemberSubset_1 = require("./space/SpaceKnockingMemberSubset");
const SpaceMemberSubset_1 = require("./space/SpaceMemberSubset");
const TokenDistributionSubset_1 = require("./token/TokenDistributionSubset");
const TokenStatsSubset_1 = require("./token/TokenStatsSubset");
class BaseSet {
    constructor(origin, apiKey, dataset) {
        this.origin = origin;
        this.apiKey = apiKey;
        this.dataset = dataset;
        this.getManyAdvancedLive = (params) => {
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY_ADVANCED + (0, fetch_utils_1.toQueryParams)(Object.assign({}, params));
            return (0, observable_1.fetchLive)(this.apiKey, url);
        };
    }
}
exports.BaseSet = BaseSet;
class BaseDataSetClass extends BaseSet {
    constructor() {
        super(...arguments);
        this.sendRequest = (name) => async (request) => {
            const isLocal = !Object.values(__1.Build5).includes(this.origin);
            const url = this.origin + `/${isLocal ? 'https-' : ''}` + name;
            try {
                return (await axios_1.default.post(url, Object.assign(Object.assign({}, request), { projectApiKey: this.apiKey }))).data;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }
            catch (error) {
                throw error.response.data;
            }
        };
    }
}
/**
 * Dataset base class.
 */
class DatasetClass extends BaseDataSetClass {
    constructor() {
        super(...arguments);
        /**
         * Get many records by id.
         *
         * @param setIds
         * @returns
         */
        this.getManyById = (setIds) => (0, fetch_utils_1.wrappedFetch)(this.apiKey, this.origin + interfaces_1.ApiRoutes.GET_MANY_BY_ID, {
            dataset: this.dataset,
            setIds,
        });
        /**
         * Get many records by id. Real time stream.
         *
         * @param setIds
         * @returns
         */
        this.getManyByIdLive = (setIds) => {
            const params = { dataset: this.dataset, setIds };
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY_BY_ID + (0, fetch_utils_1.toQueryParams)(Object.assign({}, params));
            return (0, observable_1.fetchLive)(this.apiKey, url);
        };
        /**
         * Get records by field.
         *
         * @param fieldName
         * @param fieldValue
         * @param startAfter
         * @returns
         */
        this.getByField = async (fieldName, fieldValue, startAfter) => {
            const params = { dataset: this.dataset, fieldName, fieldValue, startAfter };
            return await (0, fetch_utils_1.wrappedFetch)(this.apiKey, this.origin + interfaces_1.ApiRoutes.GET_MANY, params);
        };
        /**
         * Get records by field. Real time stream.
         * @param fieldName
         * @param fieldValue
         * @param startAfter
         * @returns
         */
        this.getByFieldLive = (fieldName, fieldValue, startAfter) => {
            const params = { dataset: this.dataset, fieldName, fieldValue, startAfter };
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY + (0, fetch_utils_1.toQueryParams)(Object.assign({}, params));
            return (0, observable_1.fetchLive)(this.apiKey, url);
        };
        /**
         * Get records by space.
         *
         * @param space
         * @param startAfter
         * @returns
         */
        this.getBySpace = async (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: 'space',
                fieldValue: space,
                startAfter,
            };
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY;
            return await (0, fetch_utils_1.wrappedFetch)(this.apiKey, url, Object.assign({}, params));
        };
        /**
         * Get records by space. Real time stream.
         * @param space
         * @param startAfter
         * @returns
         */
        this.getBySpaceLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space'],
                fieldValue: [space],
                operator: [interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        /**
         * Get all records updated after unix timestamp.
         *
         * @param updatedAfter
         * @param startAfter
         * @returns
         */
        this.getAllUpdatedAfter = async (updatedAfter, startAfter) => {
            const params = { dataset: this.dataset, updatedAfter, startAfter };
            const url = this.origin + interfaces_1.ApiRoutes.GET_UPDATED_AFTER;
            return await (0, fetch_utils_1.wrappedFetch)(this.apiKey, url, Object.assign({}, params));
        };
        /**
         * Get all records updated after unix timestamp. Real time stream.
         *
         * @param updatedAfter
         * @param startAfter
         * @returns
         */
        this.getAllUpdatedAfterLive = (updatedAfter, startAfter) => {
            const params = { dataset: this.dataset, updatedAfter, startAfter };
            const url = this.origin + interfaces_1.ApiRoutes.GET_UPDATED_AFTER + (0, fetch_utils_1.toQueryParams)(Object.assign({}, params));
            return (0, observable_1.fetchLive)(this.apiKey, url);
        };
        this.getTop = async (limit, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: [],
                fieldValue: [],
                operator: [],
                startAfter,
                limit,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY_ADVANCED;
            return await (0, fetch_utils_1.wrappedFetch)(this.apiKey, url, Object.assign({}, params));
        };
        this.getTopLive = (startAfter, limit) => {
            const params = {
                dataset: this.dataset,
                fieldName: [],
                fieldValue: [],
                operator: [],
                startAfter,
                limit,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.id = (setId) => new ExactDataSet(this.origin, this.apiKey, this.dataset, setId);
        this.subset = (subset) => new ExactDataSet(this.origin, this.apiKey, this.dataset, '').subset(subset);
    }
}
exports.DatasetClass = DatasetClass;
class ExactDataSet extends BaseSet {
    constructor(origin, apiKey, dataset, setId) {
        super(origin, apiKey, dataset);
        this.setId = setId;
        this.get = () => GetByIdGrouped_1.default.get({
            origin: this.origin,
            dataset: this.dataset,
            setId: this.setId,
            apiKey: this.apiKey,
        });
        this.getLive = () => (0, rxjs_1.from)(GetByIdGroupedLive_1.default.get({
            origin: this.origin,
            dataset: this.dataset,
            setId: this.setId,
            apiKey: this.apiKey,
        })).pipe((0, rxjs_1.switchMap)((inner) => inner));
        this.subset = (subset) => {
            switch (subset) {
                case interfaces_1.Subset.PARTICIPANTS:
                    return new AwardParticipantSubset_1.AwardParticpateSubset(this.origin, this.apiKey, this.dataset, this.setId, interfaces_1.Subset.PARTICIPANTS);
                case interfaces_1.Subset.OWNERS:
                    return new AwardOwnerSubset_1.AwardOwnerSubset(this.origin, this.apiKey, this.dataset, this.setId, interfaces_1.Subset.OWNERS);
                case interfaces_1.Subset.STATS: {
                    if (this.dataset === interfaces_1.Dataset.TOKEN) {
                        return new TokenStatsSubset_1.TokenStatsSubset(this.origin, this.apiKey, this.dataset, this.setId, interfaces_1.Subset.STATS);
                    }
                    if (this.dataset === interfaces_1.Dataset.COLLECTION) {
                        return new CollectionStatsSubset_1.CollectionStatsSubset(this.origin, this.apiKey, this.dataset, this.setId, interfaces_1.Subset.STATS);
                    }
                    throw Error('invalid subset name');
                }
                case interfaces_1.Subset.MEMBERS:
                    if (this.dataset === interfaces_1.Dataset.PROPOSAL) {
                        return new ProposalMemberSubset_1.ProposalMemberSubset(this.origin, this.apiKey, this.dataset, this.setId, interfaces_1.Subset.MEMBERS);
                    }
                    if (this.dataset === interfaces_1.Dataset.SPACE) {
                        return new SpaceMemberSubset_1.SpaceMemberSubset(this.origin, this.apiKey, this.dataset, this.setId, interfaces_1.Subset.MEMBERS);
                    }
                    throw Error('invalid subset name');
                case interfaces_1.Subset.GUARDIANS:
                    return new SpaceGuardianSubset_1.SpaceGuardianSubset(this.origin, this.apiKey, this.dataset, this.setId, interfaces_1.Subset.GUARDIANS);
                case interfaces_1.Subset.KNOCKING_MEMBERS:
                    return new SpaceKnockingMemberSubset_1.SpaceKnockingMemberSubset(this.origin, this.apiKey, this.dataset, this.setId, interfaces_1.Subset.KNOCKING_MEMBERS);
                case interfaces_1.Subset.BLOCKED_MEMBERS:
                    return new SpaceBlockedMemberSubset_1.SpaceBlockedMemberSubset(this.origin, this.apiKey, this.dataset, this.setId, interfaces_1.Subset.BLOCKED_MEMBERS);
                case interfaces_1.Subset.DISTRIBUTION:
                    return new TokenDistributionSubset_1.TokenDistributionSubset(this.origin, this.apiKey, this.dataset, this.setId, interfaces_1.Subset.DISTRIBUTION);
                case interfaces_1.Subset.TRANSACTIONS:
                    return new MilestoneTransactionSubset_1.MilestoneTransactionSubset(this.origin, this.apiKey, this.dataset, this.setId, interfaces_1.Subset.TRANSACTIONS);
                default:
                    throw Error('invalid subset name');
            }
        };
    }
}
exports.ExactDataSet = ExactDataSet;
